<template>
    <footer>
        <div class="info">
            <img src="@/assets/Footer_Title.png" alt="國立政治大學校務研究辦公室"> 
            <!-- <h2>國立政治大學校務研究辦公室</h2> -->
            <p class="info-contact">若需轉載或對本辦公室有任何建議，請與我們聯繫</p>
            <p class="contact-list email">oir@nccu.edu.tw</p>
            <p class="contact-list phone">02-2939-3091&ensp;#62760</p> 
            <div class="contact-list address">
                <p>116011&ensp;臺北市文山區指南路二段64號</p>
                <p>行政大樓二樓206室</p>
            </div>
        </div>
        <div class="copyright">
            <p>網站著作權屬於國立政治大學校務研究辦公室</p>
            <p>Copyright © 2023 NCCU Office of Institutional Research All rights reserved.</p>
            <p>感謝國立政治大學資訊科學系NCCUCS PLSM學生團隊協助建置</p>
        </div>
    </footer>
</template>

<script>

export default {
    
}
</script>

<style src="@/assets/css/footer.css" scoped></style>


